import styled from "@emotion/styled";
import { ApplicationOriginBadge } from "src/components/ApplicationOriginBadge";
import { BaseCell } from "src/components/Table/Cells/shared";

const CellContainer = styled(BaseCell)`
  flex: 0.9;
  min-width: 92px;
`;

interface OriginCellProps {
  origin?: string | null;
}

export const OriginCell = ({ origin }: OriginCellProps) => (
  <CellContainer>
    <ApplicationOriginBadge origin={origin} />
  </CellContainer>
);
